import { render } from "./goods_comment_list.vue?vue&type=template&id=4ce88cf7&scoped=true"
import script from "./goods_comment_list.vue?vue&type=script&lang=js"
export * from "./goods_comment_list.vue?vue&type=script&lang=js"

import "./goods_comment_list.vue?vue&type=style&index=0&id=4ce88cf7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce88cf7"]])

export default __exports__